export default state => state.rails
